import Section from '@/components/Mini/Section'
import { events } from '@/models/analytics/analytics-events'
import { BadgesSummaryCard } from '@/screens/badges-screen/BadgesSummaryCard'

/** Play-screen "Badges" section: header + shared summary card. */
export const BadgesTeaser = () => (
  <Section title="Your Badges">
    <BadgesSummaryCard analyticsEvent={events.badges.teaser_tapped} />
  </Section>
)
